import { useEffect, useState } from "react";
const CURRENT_PROJECT_KEY = "CURRENT_PROJECT_KEY_PENN_DOT_ICE";

// custom hook that keeps the currentProjectKey synched between the
// react state and the sessionStorage
export const useCurrentProjectKey = () => {
  const [currentProjectKey, setCurrentProjectKey] = useState(
    sessionStorage.getItem(CURRENT_PROJECT_KEY)
  );

  useEffect(() => {
    sessionStorage.setItem(CURRENT_PROJECT_KEY, currentProjectKey);
  }, [currentProjectKey]);

  return [currentProjectKey, setCurrentProjectKey];
};
